const state = {
    // 登陆状态
    loginStatu: false,
    // 用户ID
    uid: '',
    // 歌曲ID
    songID: '',
    // 播放列表
    playList: [],
    // 播放历史
    playHistory: [],
    // 播放状态
    playIng: false,
    // 歌词
    lyric: '',
    // 所见即所得
    term: ''
}

export default state